<template>
    <div>
        <main-banner></main-banner>
        <main-body></main-body>
        <!-- 滚动到顶部 -->
        <a href="javascript:;" 
            class="back-to-top" 
            @click="scrollTop"
            v-show="showScroll>=300">
            <span class="glyphicon glyphicon-menu-up"></span>
            <span>{{$t("message.main.backtop")}}</span>
        </a>
    </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'

export default {
    data(){
        return {
            showScroll:""
        }
    },
    components: {
        mainBanner: () => import("@/components/mainBanner"),
        mainBody: () => import("@/components/mainBody"),
    },
    methods: {
        ...mapMutations([
            "handleLoading"
        ]),
        ...mapActions([
            "getMainCarousel", // 轮播图
            "getMenu", // 菜单栏
            "getStar", // 明星商品
            "getHot", // 热销商品
            "getMainGoods", // 首页商品
            "getMainBanner", // 分类间广告
            "getMainInstructions", // 产品试用说明
        ]),
        // 获取当前位置
        handleScroll(){
            var scrollTop = window.pageYOffset ||document.documentElement.scrollTop || document.body.scrollTop 
            this.showScroll = scrollTop;
        },
        // 回到顶部按钮
        scrollTop(){
            this.$parent.$el.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
        }
    },
    beforeRouteEnter (to, from, next) {
        // ...
        next(vm => {
            vm.getMainCarousel();
            vm.getMenu();
            vm.getStar();
            vm.getHot();
            vm.getMainGoods();
            vm.getMainBanner();
            vm.getMainInstructions();
            window.addEventListener('scroll', vm.handleScroll);
        })
    },
    beforeRouteLeave (to, from, next) {
        window.removeEventListener("scroll", this.handleScroll);
        next();
    }
}
</script>

<style scoped>
/*楼层滚动按钮*/
.back-to-top{
    position: fixed;
    bottom: 100px;
    right: 0px;
    display: block;
    width: 80px;
    height: 55px;
    border-radius: 5px;
    color: #fff;
    background-color: rgba(0,0,0,0.2);
    z-index: 1100;
}
.back-to-top>span{
    display: block;
    text-align: center;
    line-height: 25px;
}
@media screen and (max-width: 1199px) {
    .back-to-top{
        width: 27px;
        height: 135px;
    }
}
</style>
